/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import type { TrelloWindow } from '@trello/window-types';

import { tryBabble } from 'app/scripts/lib/try-babble';

declare const window: TrelloWindow;

export const localizeCount = function (
  key: string,
  count: number | string | undefined,
  data?: object,
  options?: object,
) {
  const { counting } = window.__locale;
  if (data == null) {
    data = {};
  }
  if (options == null) {
    options = {};
  }
  const args = {
    count: String(count),
    ...data,
  };
  return tryBabble(['counts', key, counting(count)], args, options);
};
